import createHistory from "history/createBrowserHistory";
import { syncHistoryWithStore } from "mobx-react-router";
import { Auth } from "@okta/okta-react";
import SetiApi from "../httpClients/setiApi";
import LimboApi from "../httpClients/limboApi";
import GroundTruthStore from "./groundTruthStore";
import StrikeZoneChartStore from "./strikeZoneChartStore";
import StrikeZoneTableStore from "./strikeZoneTableStore";
import QuestionableCallsStore from "./questionableCallsStore";
import ModelBasedAlertingStore from "./modelBasedAlertingStore";
import TrackmanAccuracyReportStore from "./trackmanAccuracyReportStore";
import LimboStore from "./limboStore";
import SetiRouterStore from "./setiRouterStore";
import AuthStore from "./authStore";

const onAuthRequired = ({ history }) => {
  history.push("/login");
};

class RootStore {
  constructor() {
    this.routerStore = new SetiRouterStore();
    this.history = syncHistoryWithStore(createHistory(), this.routerStore);
    const auth = new Auth({
      history: this.history,
      issuer: process.env.REACT_APP_OKTA_ISSUER,
      clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
      redirectUri: window.location.origin + "/implicit/callback",
      onAuthRequired: onAuthRequired
    });
    this.authStore = new AuthStore(this.routerStore, auth);
    this.authStore.getUser();
    this.setiApi = new SetiApi();
    this.limboApi = new LimboApi();
    this.strikeZoneChartStore = new StrikeZoneChartStore(this.setiApi);
    this.strikeZoneTableStore = new StrikeZoneTableStore(
      this.setiApi,
      this.routerStore
    );
    this.questionableCallsStore = new QuestionableCallsStore(this.setiApi);
    this.modelBasedAlertingStore = new ModelBasedAlertingStore(
      this.setiApi,
      this.routerStore
    );
    this.groundTruthStore = new GroundTruthStore(
      this.setiApi,
      this.routerStore
    );
    this.limboStore = new LimboStore(
      this.limboApi,
      this.routerStore,
      this.authStore
    );
    this.trackmanAccuracyReportStore = new TrackmanAccuracyReportStore(
      this.setiApi,
      this.routerStore,
      this.limboStore
    );
  }
}

export default RootStore;



// WEBPACK FOOTER //
// ./src/stores/rootStore.js